import script from "./StatisticsView.vue?vue&type=script&setup=true&lang=ts"
export * from "./StatisticsView.vue?vue&type=script&setup=true&lang=ts"

import "./StatisticsView.vue?vue&type=style&index=0&id=20da059a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20da059a"]])

export default __exports__